export function dispatchErrorOccurred(controller, error, message, context = {}) {
    const errorOccurredDetail = {
        error,
        context,
    };
    if (message) {
        if (typeof message === "string") {
            errorOccurredDetail.userNotification = {
                message,
            };
        }
        else {
            errorOccurredDetail.userNotification = message;
        }
    }
    controller.dispatch("errorOccurred", { detail: errorOccurredDetail, prefix: "" });
}
const expiredLoginMessage = "La sesión ha expirado por completo y se requiere iniciar" +
    " sesión nuevamente. Disculpe el inconveniente. Redireccionando a login...";
export function dispatchExpiredLoginErrorOccurred(controller, error) {
    dispatchErrorOccurred(controller, error, expiredLoginMessage);
}
const unknownErrorMessage = "Se presentó un problema inesperado. Por favor, intente" +
    " nuevamente, ó contacte a soporte";
export function dispatchUnexpectedErrorOccurred(controller, error, context = {}) {
    dispatchErrorOccurred(controller, error, unknownErrorMessage, context);
}
//# sourceMappingURL=erroroccurred.js.map